module.exports = __webpack_public_path__ + "img/logo-fundacion-forge-footer.52fa8324.png";